import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DistributorService {


  url = environment.serverAPI4 + "/api/distributor";

  constructor(private http: HttpClient) { }

  getAllDistributor(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllDistributorDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getDistributorById(aiChatBotId: number): Observable<Object> {
    return this.http.get(`${this.url}/${aiChatBotId}`);
  }

  addOrEditDistributor(AiChatBot: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, AiChatBot);
  }

  searchDistributor(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
}
